import { apiCredSystem } from '~/credsystem/services/apiCredSystem';

interface APIResponse {
  httpStatusCode: number;
  data: {
    mensagem: string;
    ddd: string;
    ultimosDigitos: string;
  };
}

export async function sendCredsystemSmsUseCase(): Promise<APIResponse | null> {
  try {
    const response = await apiCredSystem.post<APIResponse>(
      `/api/v1/identificacao/token-sms/envio`,
      {
        telefone: null,
      }
    );

    return response?.data;
  } catch (error) {
    return null;
  }
}
